export const authenticate = (host, documentid, appSessionId, sessionId) => {
  // call the server so we can check auth and get our cookies set
  return fetch(
    `https://${host}.scribonline.com/stepimage?action=load&docisd=${documentid}&imaging.DCAppSesSesIDV1_0=${appSessionId}&imaging.DCAppSesIDV1_0=${sessionId}`,
    {
      method: 'GET',
      credentials: 'include'
    }
  )
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject(`Returned code ${response.status}`);
      }
      var contentType = response.headers.get('content-type');
      if (contentType === 'text/html') {
        return Promise.reject('NotAuthenticated');
      }
      // check to make sure this isnt a redirect and is a valid repsonse
      return response.text();
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const getUserInformation = (host, appSessionId, sessionId) => {
  return fetch(
    `https://${host}.scribonline.com/getUserInfo?&imaging.DCAppSesSesIDV1_0=${appSessionId}&imaging.DCAppSesIDV1_0=${sessionId}`,
    {
      method: 'GET',
      credentials: 'include'
    }
  )
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject(`Returned code ${response.status}`);
      }
      var contentType = response.headers.get('content-type');
      if (contentType === 'text/html') {
        return Promise.reject('NotAuthenticated');
      }
      // check to make sure this isnt a redirect and is a valid repsonse
      return response.json();
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const getDocumentArrayBuffer = (
  host,
  documentid,
  appSessionId,
  sessionId
) => {
  // call the server so we can check auth and get our cookies set
  return fetch(
    `https://${host}.scribonline.com/pdfexport.pdf?image.superid=${documentid}&imaging.DCAppSesSesIDV1_0=${appSessionId}&imaging.DCAppSesIDV1_0=${sessionId}`,
    {
      method: 'GET',
      credentials: 'include'
    }
  )
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject(`Returned code ${response.status}`);
      }
      var contentType = response.headers.get('content-type');
      if (contentType === 'text/html') {
        return Promise.reject('NotAuthenticated');
      }
      console.log('response', response);
      return response.arrayBuffer();
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const updateModifiedDate = (
  host,
  documentid,
  appSessionId,
  sessionId
) => {
  // call the server so we can check auth and get our cookies set
  return fetch(
    `https://${host}.scribonline.com/updateModifiedTime?image.superid=${documentid}&imaging.DCAppSesSesIDV1_0=${appSessionId}&imaging.DCAppSesIDV1_0=${sessionId}`,
    {
      method: 'GET',
      credentials: 'include'
    }
  )
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject(`Returned code ${response.status}`);
      }
      var contentType = response.headers.get('content-type');
      if (contentType === 'text/html') {
        return Promise.reject('NotAuthenticated');
      }
      return response.arrayBuffer();
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const loadDCIP = (host, documentid, appSessionId, sessionId) => {
  // call the server so we can check auth and get our cookies set
  return fetch(
    `https://${host}.scribonline.com/stepimage?action=load&docisd=${documentid}&imaging.DCAppSesSesIDV1_0=${appSessionId}&imaging.DCAppSesIDV1_0=${sessionId}`,
    {
      method: 'GET',
      credentials: 'include'
    }
  )
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject(`Returned code ${response.status}`);
      }

      return response.text();
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const deletePage = (
  host,
  documentid,
  pageNum,
  appSessionId,
  sessionId
) => {
  // call the server so we can check auth and get our cookies set
  return fetch(
    `https://${host}.scribonline.com/deletePage?image.superid=${documentid}&pagenumber=${pageNum}&imaging.DCAppSesSesIDV1_0=${appSessionId}&imaging.DCAppSesIDV1_0=${sessionId}`,
    {
      method: 'GET',
      credentials: 'include'
    }
  )
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject(`Returned code ${response.status}`);
      }

      return response.text();
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const savePageOrder = (
  host,
  documentid,
  newOrder,
  appSessionId,
  sessionId
) => {
  console.log(JSON.stringify(newOrder));
  return fetch(
    `https://${host}.scribonline.com/reorderPages?image.superid=${documentid}&imaging.DCAppSesSesIDV1_0=${appSessionId}&imaging.DCAppSesIDV1_0=${sessionId}&getstream=true`,
    {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'text/plain'
      },
      mode: 'cors', // no-cors
      body: JSON.stringify(newOrder)
    }
  )
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject(`Returned code ${response.status}`);
      }
      return response.text();
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const actualInsertPage = (
  host,
  documentid,
  appSessionId,
  sessionId,
  exportObject
) => {
  console.log(JSON.stringify(exportObject));
  return fetch(
    `https://${host}.scribonline.com/insertPage?image.superid=${documentid}&imaging.DCAppSesSesIDV1_0=${appSessionId}&imaging.DCAppSesIDV1_0=${sessionId}&getstream=true`,
    {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'text/plain'
      },
      mode: 'cors', // no-cors
      body: JSON.stringify(exportObject)
    }
  )
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject(`Returned code ${response.status}`);
      }
      return response.text();
    })
    .catch(error => {
      return Promise.reject(error);
    });
};
